<template>
    <div>
        <div class="modal-close-btn-point">
            <div class="modal-close-btn-container" v-on:click="$emit('close')">
                <SVGModalClose/>
            </div>
        </div>
        <div class="ap-modal-title-big">
            Редактировать организацию
        </div>
        <OrganizationDataEntryFields @apply="apply" :buttonName="'Добавить'" :dataOrganization="organizationData"/>
    </div>
</template>

<script>
import OrganizationDataEntryFields from "./OrganizationDataEntryFields";
import SVGModalClose from "../../../SVG/SVGModalClose";

export default {
    name: "EditOrganization",
    components: {
        SVGModalClose,
        OrganizationDataEntryFields
    },
    props: {
        buttonName: {
            type: String,
            default: 'Нет названия'
        },
        organizationData: {
            type: Object,
            default() {
                return {};
            }
        },
    },
    methods:{
        apply(newData){
            newData.id = this.organizationData.id;
            this.$store.dispatch('adminPanel/organizations/SAVE_ORGANIZATION', newData);
            this.$emit('close');
        }
    }
}
</script>

<style scoped>

</style>